const Toggle = ({ checked, onChange, disabled = false }) => (
  <button
    type="button"
    onClick={() => !disabled && onChange(!checked)}
    disabled={disabled}
    className={`photon-switch relative inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full transition-colors focus:outline-none ${
      disabled ? "opacity-40 cursor-not-allowed" : "cursor-pointer"
    } ${checked ? "bg-fill-violet-600" : "bg-fill-gray-300 dark:bg-fill-gray-600"}`}
    role="switch"
    aria-checked={checked}
  >
    <span
      className={`inline-block h-3.5 w-3.5 transform rounded-full bg-fill-white shadow transition-transform ${
        checked ? "translate-x-[18px]" : "translate-x-[2px]"
      }`}
    />
  </button>
);

export default Toggle;
